import React, { useEffect, useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { ROUTES } from '../../../shared/utils/constants';
import { SESSION_EXPIRED_EVENT } from '../../../lib/sessionExpiry';

/**
 * Listens for the session-expired event dispatched by the axios interceptor and
 * prompts the user to log back in. Non-dismissible - the only way out is to log
 * in again, which owns the redirect (previously done silently in the interceptor).
 */
export const SessionExpiredDialog: React.FC = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const handleExpired = () => {
      // Nothing to prompt if the user is already on the login route (e.g. a
      // route-loader redirect already took them there on session expiry).
      if (window.location.pathname === ROUTES.LOGIN) return;
      setOpen(true);
    };
    window.addEventListener(SESSION_EXPIRED_EVENT, handleExpired);
    return () => window.removeEventListener(SESSION_EXPIRED_EVENT, handleExpired);
  }, []);

  const handleLogin = () => {
    window.location.href = ROUTES.LOGIN;
  };

  return (
    <Dialog open={open} disableEscapeKeyDown>
      <DialogTitle>Session expired</DialogTitle>
      <DialogContent>
        <DialogContentText>You have been logged out. Please log back in to continue.</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant='contained' onClick={handleLogin} autoFocus>
          Log in
        </Button>
      </DialogActions>
    </Dialog>
  );
};
